import * as React from "react"
import { Hidden, Row } from "react-grid-system"
import Subtitle from "../../atoms/typography/Subtitle"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import TextInput from "../../molecules/TextInput"
import H4 from "../../atoms/typography/H4"
import { useResetPassword } from "../../../hooks/useResetPassword"
import { checkEmailValid } from "../../../utils/helpers"
import H3 from "../../atoms/typography/H3"
import { theme } from "../../../components/theme"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import { ApolloError } from "@apollo/client"
import { captureExceptionWithContext } from "../../../utils/sentry"

const Content = styled.div`
  padding: 2rem 3rem;
  width: 40vw;

  ${MediaQuery.SM} {
    width: 40vw;
  }

  ${MediaQuery.XS} {
    width: 90vw;
    padding: 1rem;
  }
`

interface Props {
  onClickCancelForgotPassowrd: () => void
}

const ResetPassword: React.FunctionComponent<Props> = ({ onClickCancelForgotPassowrd }) => {
  const [email, setEmail] = React.useState("")
  const [emailSent, setEmailSent] = React.useState(false)

  const onCompletedResetPassword = (data: any) => {
    if (!data?.resetPasswordRequest?.errors) {
      const timer = setTimeout(() => {
        setEmailSent(true)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }
  const onErrorResetPassword = (apolloError: ApolloError) => {
    captureExceptionWithContext(apolloError, "Error in reset password")
  }
  const { resetPassword, data, loading } = useResetPassword({
    onCompleted: (data: any) => onCompletedResetPassword(data),
    onError: onErrorResetPassword,
  })
  const onResetPassword = async () => {
    try {
      await resetPassword({
        variables: {
          email: email,
        },
      })
    } catch (error) {
      captureExceptionWithContext(error, "Error in reset password")
    }
  }

  return (
    <Row justify="center">
      <Content>
        <HorizontalSpacer spacing={1} />
        <Subtitle textAlign="center">Reset password</Subtitle>
        <HorizontalSpacer spacing={3} />
        <H4 textAlign="center">
          To reset your password, please enter your email address and then check your emails for a new password form.
        </H4>
        <HorizontalSpacer spacing={3} />
        <TextInput textFieldTitle="Email" onChange={(e) => setEmail(e.target.value)} id="email" />

        <HorizontalSpacer spacing={3} />
        <Row justify="center">
          <Hidden xs>
            <>
              <PrimaryButton title="Cancel" onClick={onClickCancelForgotPassowrd} />
              <Spacer spacing={2} />
            </>
          </Hidden>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <SecondaryButton title="Reset password" onClick={onResetPassword} disabled={!checkEmailValid(email)} />
          )}
        </Row>
        {emailSent && (
          <>
            <HorizontalSpacer spacing={2} />
            <Row justify="center">
              <H3 color={theme.colors.greenDark}>Email sent to {email}</H3>
            </Row>
          </>
        )}
        <HorizontalSpacer spacing={1} />
      </Content>
    </Row>
  )
}

export default ResetPassword
